let _initProto, _initClass, _init_variant, _init_extra_variant, _init_side, _init_extra_side, _init_collapsible, _init_extra_collapsible, _init_defaultWidth, _init_extra_defaultWidth, _init_width, _init_extra_width, _init_minWidth, _init_extra_minWidth, _init_maxWidth, _init_extra_maxWidth, _init_resizable, _init_extra_resizable, _init_defaultOpen, _init_extra_defaultOpen, _init_mobileDefaultOpen, _init_extra_mobileDefaultOpen, _init_open, _init_extra_open, _init_mobileBreakpoint, _init_extra_mobileBreakpoint, _init_label, _init_extra_label, _init_matchActive, _init_extra_matchActive, _init_matchMode, _init_extra_matchMode, _init_scrollActiveOnMount, _init_extra_scrollActiveOnMount, _init_navigationEvents, _init_extra_navigationEvents, _init_rootTarget, _init_extra_rootTarget, _init_paneTarget, _init_extra_paneTarget, _init_handleTarget, _init_extra_handleTarget, _init_scrimTarget, _init_extra_scrimTarget, _init_toggleEvent, _init_extra_toggleEvent, _init_resizeEvent, _init_extra_resizeEvent, _init_mobileChangeEvent, _init_extra_mobileChangeEvent, _init_isMobile, _init_extra_isMobile;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, bound, customElement, event, onEvent, onUpdated, prop, query, state } from "@ecopages/radiant";
import { isServer } from "@ecopages/radiant/is-server";
import { parseCommaSeparated } from "@/lib/comma-separated";
const DEFAULT_WIDTH = 256;
const ICON_WIDTH = 48;
const DEFAULT_MIN_WIDTH = 200;
const DEFAULT_MAX_WIDTH = 480;
const DEFAULT_MOBILE_BREAKPOINT = 768;
const KEYBOARD_SHORTCUT = "b";
const KEYBOARD_STEP = 8;
const KEYBOARD_STEP_LARGE = 32;
const MENU_LINK_SELECTOR = "a.rui-sidebar__menu-button";
function isModifierPressed(event2) {
  return event2.metaKey || event2.ctrlKey;
}
function isMediaQuerySupported() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}
function isHorizontalSide(side) {
  return side === "left" || side === "right";
}
let _RuiSidebar;
class RuiSidebar extends RadiantElement {
  static {
    ({
      e: [_init_variant, _init_extra_variant, _init_side, _init_extra_side, _init_collapsible, _init_extra_collapsible, _init_defaultWidth, _init_extra_defaultWidth, _init_width, _init_extra_width, _init_minWidth, _init_extra_minWidth, _init_maxWidth, _init_extra_maxWidth, _init_resizable, _init_extra_resizable, _init_defaultOpen, _init_extra_defaultOpen, _init_mobileDefaultOpen, _init_extra_mobileDefaultOpen, _init_open, _init_extra_open, _init_mobileBreakpoint, _init_extra_mobileBreakpoint, _init_label, _init_extra_label, _init_matchActive, _init_extra_matchActive, _init_matchMode, _init_extra_matchMode, _init_scrollActiveOnMount, _init_extra_scrollActiveOnMount, _init_navigationEvents, _init_extra_navigationEvents, _init_rootTarget, _init_extra_rootTarget, _init_paneTarget, _init_extra_paneTarget, _init_handleTarget, _init_extra_handleTarget, _init_scrimTarget, _init_extra_scrimTarget, _init_toggleEvent, _init_extra_toggleEvent, _init_resizeEvent, _init_extra_resizeEvent, _init_mobileChangeEvent, _init_extra_mobileChangeEvent, _init_isMobile, _init_extra_isMobile, _initProto],
      c: [_RuiSidebar, _initClass]
    } = _applyDecs(this, [customElement("rui-sidebar")], [[prop({
      type: String,
      reflect: true,
      defaultValue: "sidebar"
    }), 0, "variant"], [prop({
      type: String,
      reflect: true,
      defaultValue: "left"
    }), 0, "side"], [prop({
      type: String,
      reflect: true,
      defaultValue: "off"
    }), 0, "collapsible"], [prop({
      type: Number,
      defaultValue: DEFAULT_WIDTH
    }), 0, "defaultWidth"], [prop({
      type: Number,
      reflect: true,
      attribute: "width"
    }), 0, "width"], [prop({
      type: Number,
      defaultValue: DEFAULT_MIN_WIDTH
    }), 0, "minWidth"], [prop({
      type: Number,
      defaultValue: DEFAULT_MAX_WIDTH
    }), 0, "maxWidth"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "resizable"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "defaultOpen"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "mobileDefaultOpen"], [prop({
      type: Boolean,
      attribute: "open"
    }), 0, "open"], [prop({
      type: Number,
      defaultValue: DEFAULT_MOBILE_BREAKPOINT
    }), 0, "mobileBreakpoint"], [prop({
      type: String,
      defaultValue: "Sidebar"
    }), 0, "label"], [prop({
      type: Boolean,
      reflect: true,
      attribute: "match-active"
    }), 0, "matchActive"], [prop({
      type: String,
      defaultValue: "pathname"
    }), 0, "matchMode"], [prop({
      type: Boolean,
      attribute: "scroll-active-on-mount"
    }), 0, "scrollActiveOnMount"], [prop({
      type: String,
      attribute: "navigation-events",
      defaultValue: ""
    }), 0, "navigationEvents"], [query({
      ref: "root"
    }), 0, "rootTarget"], [query({
      ref: "pane"
    }), 0, "paneTarget"], [query({
      ref: "handle"
    }), 0, "handleTarget"], [query({
      ref: "scrim"
    }), 0, "scrimTarget"], [event({
      name: "rui-sidebar-toggle",
      bubbles: true,
      composed: true
    }), 0, "toggleEvent"], [event({
      name: "rui-sidebar-resize",
      bubbles: true,
      composed: true
    }), 0, "resizeEvent"], [event({
      name: "rui-sidebar-mobile-change",
      bubbles: true,
      composed: true
    }), 0, "mobileChangeEvent"], [state, 0, "isMobile"], [onUpdated(["open", "collapsible", "variant", "side", "width", "defaultWidth", "defaultOpen", "minWidth", "maxWidth", "isMobile", "resizable", "label"]), 2, "onStateUpdated"], [onUpdated(["mobileBreakpoint"]), 2, "onMobileBreakpointUpdated"], [onUpdated(["matchActive", "matchMode", "navigationEvents"]), 2, "onMatchSettingsUpdated"], [bound, 2, "onPointerMove"], [bound, 2, "onPointerUp"], [onEvent({
      ref: "handle",
      type: "pointerdown"
    }), 2, "onHandlePointerDown"], [onEvent({
      ref: "handle",
      type: "keydown"
    }), 2, "onHandleKeydown"], [onEvent({
      ref: "scrim",
      type: "click"
    }), 2, "onScrimClick"], [onEvent({
      selector: MENU_LINK_SELECTOR,
      type: "click"
    }), 2, "onMenuLinkClick"], [onEvent({
      document: true,
      type: "keydown"
    }), 2, "onHostKeydown"]], 0, void 0, RadiantElement));
  }
  variant = (_initProto(this), _init_variant(this));
  side = (_init_extra_variant(this), _init_side(this));
  collapsible = (_init_extra_side(this), _init_collapsible(this));
  defaultWidth = (_init_extra_collapsible(this), _init_defaultWidth(this));
  width = (_init_extra_defaultWidth(this), _init_width(this));
  minWidth = (_init_extra_width(this), _init_minWidth(this));
  maxWidth = (_init_extra_minWidth(this), _init_maxWidth(this));
  resizable = (_init_extra_maxWidth(this), _init_resizable(this));
  defaultOpen = (_init_extra_resizable(this), _init_defaultOpen(this));
  mobileDefaultOpen = (_init_extra_defaultOpen(this), _init_mobileDefaultOpen(this));
  open = (_init_extra_mobileDefaultOpen(this), _init_open(this));
  mobileBreakpoint = (_init_extra_open(this), _init_mobileBreakpoint(this));
  label = (_init_extra_mobileBreakpoint(this), _init_label(this));
  matchActive = (_init_extra_label(this), _init_matchActive(this, false));
  matchMode = (_init_extra_matchActive(this), _init_matchMode(this));
  scrollActiveOnMount = (_init_extra_matchMode(this), _init_scrollActiveOnMount(this, false));
  navigationEvents = (_init_extra_scrollActiveOnMount(this), _init_navigationEvents(this, ""));
  rootTarget = (_init_extra_navigationEvents(this), _init_rootTarget(this));
  paneTarget = (_init_extra_rootTarget(this), _init_paneTarget(this));
  handleTarget = (_init_extra_paneTarget(this), _init_handleTarget(this));
  scrimTarget = (_init_extra_handleTarget(this), _init_scrimTarget(this));
  toggleEvent = (_init_extra_scrimTarget(this), _init_toggleEvent(this));
  resizeEvent = (_init_extra_toggleEvent(this), _init_resizeEvent(this));
  mobileChangeEvent = (_init_extra_resizeEvent(this), _init_mobileChangeEvent(this));
  isMobile = (_init_extra_mobileChangeEvent(this), _init_isMobile(this, false));
  mediaQuery = (_init_extra_isMobile(this), null);
  mediaListener = event2 => this.setMobile(event2.matches);
  dragging = false;
  dragStartCoord = 0;
  dragStartSize = 0;
  navigationCleanups = [];
  /** @remarks Remains `false` until a projected active link has been scrolled. */
  didScrollActiveOnMount = false;
  /**
   * @remarks Captured once before defaults are applied. `setOpen` later assigns
   * `open`, which must not be mistaken for a controlled binding.
   */
  openControlled = false;
  /**
   * @remarks Viewport policy must not run until connect has snapshotted
   * `open` and applied defaults. Deferred JSX props can update
   * `mobileBreakpoint` before that microtask.
   */
  mobileReady = false;
  connectedCallback() {
    super.connectedCallback();
    this.ensureWidthInitialized();
    this.setAttribute("role", "complementary");
    this.setAttribute("aria-label", this.label);
    this.syncPresentation();
    this.attachNavigationListeners();
  }
  onConnected() {
    this.ensureWidthInitialized();
    this.openControlled = this.open !== void 0;
    this.bindMobileMediaQuery();
    if (!this.openControlled) {
      this.open = this.isMobile ? this.mobileDefaultOpen : this.defaultOpen;
    }
    this.syncPresentation();
    this.syncPaneWidthVar();
    this.syncActiveLinksAfterRender(true);
    this.mobileReady = true;
  }
  /**
   * @remarks Light-DOM hydrate/update can recreate menu links after the connect
   * microtask sync. Re-apply active classes once the render commits.
   */
  hydrate() {
    super.hydrate();
    this.syncActiveLinksAfterRender(true);
  }
  update() {
    super.update();
    this.syncActiveLinksAfterRender(false);
  }
  requestUpdate() {
    super.requestUpdate();
    queueMicrotask(() => {
      this.syncActiveLinksAfterRender(false);
    });
  }
  disconnectedCallback() {
    this.endDrag();
    this.unbindMobileMediaQuery();
    this.detachNavigationListeners();
    this.mobileReady = false;
    super.disconnectedCallback();
  }
  syncActiveLinksAfterRender(allowScrollOnMount) {
    const shouldScroll = allowScrollOnMount && this.scrollActiveOnMount && !this.didScrollActiveOnMount;
    this.syncActiveLinks(shouldScroll);
    if (shouldScroll) {
      this.didScrollActiveOnMount = true;
    }
  }
  /**
   * Keep host and inner shell `data-*` in sync. Host attrs drive
   * `:has(> rui-sidebar[...])`; inner `.rui-sidebar` drives visual styles.
   */
  syncPresentation() {
    const horizontal = isHorizontalSide(this.side);
    const open = this.isOpen();
    const paneState = open ? "expanded" : "collapsed";
    const showHandle = this.resizable && this.collapsible === "off" && open && !this.isMobile;
    const paneInert = !(open || !this.isMobile && this.collapsible === "icon");
    const paneWidth = this.paneWidth();
    this.setAttribute("data-state", paneState);
    this.setAttribute("data-collapsible", this.collapsible);
    this.setAttribute("data-variant", this.variant);
    this.setAttribute("data-side", this.side);
    this.setAttribute("data-mobile", String(this.isMobile));
    this.setAttribute("data-pane-width", String(paneWidth));
    const root = this.rootTarget;
    if (root) {
      root.dataset.state = paneState;
      root.dataset.collapsible = this.collapsible;
      root.dataset.variant = this.variant;
      root.dataset.side = this.side;
      root.dataset.mobile = String(this.isMobile);
    }
    const scrim = this.scrimTarget;
    if (scrim) {
      scrim.toggleAttribute("hidden", !(this.isMobile && open));
    }
    const pane = this.paneTarget;
    if (pane) {
      pane.dataset.side = this.side;
      pane.dataset.variant = this.variant;
      pane.setAttribute("aria-label", this.label);
      if (paneInert) {
        pane.setAttribute("inert", "");
      } else {
        pane.removeAttribute("inert");
      }
    }
    const handle = this.handleTarget;
    if (handle) {
      handle.toggleAttribute("hidden", !showHandle);
      if (showHandle) {
        handle.setAttribute("aria-orientation", horizontal ? "vertical" : "horizontal");
        handle.setAttribute("aria-valuenow", String(paneWidth));
        handle.setAttribute("aria-valuemin", String(this.minWidth));
        handle.setAttribute("aria-valuemax", String(this.maxWidth));
        handle.setAttribute("aria-label", `${this.label} resize handle`);
      }
    }
  }
  isOpen() {
    return this.open !== void 0 ? this.open : this.defaultOpen;
  }
  /**
   * Optional `Number` props initialize to `0` when no attribute/default is set
   * (`defaultValueForType(Number)`). Treat that unset `0` as “use defaultWidth”.
   */
  ensureWidthInitialized() {
    if (this.hasAttribute("width")) return;
    if (this.width === void 0 || this.width === 0) {
      this.width = this.defaultWidth;
    }
  }
  onStateUpdated() {
    this.syncPresentation();
    this.syncPaneWidthVar();
  }
  onMobileBreakpointUpdated() {
    this.bindMobileMediaQuery();
  }
  onMatchSettingsUpdated() {
    this.detachNavigationListeners();
    this.attachNavigationListeners();
    this.syncActiveLinks(false);
  }
  /** Re-applies active classes on descendant menu links from the current URL. */
  syncActiveLinks(scrollActiveIntoView = false) {
    if (!this.matchActive || typeof window === "undefined" || typeof window.location === "undefined") {
      return false;
    }
    const currentPath = window.location.pathname;
    let didScrollActiveLink = false;
    for (const link of this.querySelectorAll(MENU_LINK_SELECTOR)) {
      const active = this.isLinkActive(link, currentPath);
      link.classList.toggle("rui-sidebar__menu-button--active", active);
      if (active) {
        link.setAttribute("aria-current", "page");
        if (scrollActiveIntoView && !didScrollActiveLink) {
          link.scrollIntoView({
            block: "nearest"
          });
          didScrollActiveLink = true;
        }
      } else {
        link.removeAttribute("aria-current");
      }
    }
    return didScrollActiveLink;
  }
  isLinkActive(link, currentPath) {
    const linkPath = link.pathname;
    if (this.matchMode === "prefix") {
      return currentPath === linkPath || currentPath.startsWith(`${linkPath}/`);
    }
    return linkPath === currentPath;
  }
  attachNavigationListeners() {
    if (isServer || !this.isConnected) {
      return;
    }
    if (!this.matchActive || typeof window === "undefined" || typeof window.addEventListener !== "function") {
      return;
    }
    const handler = () => this.syncActiveLinks(false);
    window.addEventListener("popstate", handler);
    this.navigationCleanups.push(() => window.removeEventListener("popstate", handler));
    if (typeof document !== "undefined" && typeof document.addEventListener === "function") {
      for (const eventName of parseCommaSeparated(this.navigationEvents)) {
        document.addEventListener(eventName, handler);
        this.navigationCleanups.push(() => document.removeEventListener(eventName, handler));
      }
    }
  }
  detachNavigationListeners() {
    for (const cleanup of this.navigationCleanups) {
      cleanup();
    }
    this.navigationCleanups = [];
  }
  unbindMobileMediaQuery() {
    this.mediaQuery?.removeEventListener("change", this.mediaListener);
    this.mediaQuery = null;
  }
  bindMobileMediaQuery() {
    this.unbindMobileMediaQuery();
    if (this.mobileBreakpoint <= 0 || !isMediaQuerySupported()) {
      this.setMobile(false);
      return;
    }
    this.mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint - 1}px)`);
    this.mediaQuery.addEventListener("change", this.mediaListener);
    this.setMobile(this.mediaQuery.matches);
  }
  /**
   * Flip between mobile drawer and inline layout.
   *
   * @remarks
   * After connect, entering mobile applies `mobileDefaultOpen` so a
   * desktop-open pane does not become an overlay drawer. Leaving mobile while
   * closed with `collapsible="off"` reopens — desktop hides reopen triggers for
   * that mode, so a closed drawer would otherwise stick at width 0. Controlled
   * `open` is left alone; other collapsible modes keep the consumer's open
   * state when leaving mobile.
   */
  setMobile(next) {
    if (next === this.isMobile) return;
    const leavingMobile = this.isMobile && !next;
    const enteringMobile = !this.isMobile && next;
    this.isMobile = next;
    const applyPolicy = this.mobileReady && !this.openControlled;
    if (applyPolicy && leavingMobile && this.collapsible === "off" && !this.isOpen()) {
      this.setOpen(true);
    } else if (applyPolicy && enteringMobile) {
      this.setOpen(this.mobileDefaultOpen);
    } else {
      this.syncPaneWidthVar();
    }
    this.mobileChangeEvent.emit({
      mobile: next
    });
  }
  clampWidth(next) {
    return Math.min(this.maxWidth, Math.max(this.minWidth, next));
  }
  /**
   * @remarks Mobile is always a full drawer — never leave an icon rail when closed.
   */
  paneWidth() {
    if (!this.isOpen()) {
      if (this.isMobile) return 0;
      return this.collapsible === "icon" ? ICON_WIDTH : 0;
    }
    const configured = this.width && this.width > 0 ? this.width : this.defaultWidth;
    return configured;
  }
  /** Drive layout through the CSS variable only — never set inline pane width. */
  syncPaneWidthVar(width = this.paneWidth()) {
    const root = this.rootTarget;
    if (root) {
      root.style.setProperty("--rui-sidebar-pane-width", `${width}px`);
    }
    if (this.paneTarget) {
      this.paneTarget.style.removeProperty("width");
      this.paneTarget.style.removeProperty("height");
    }
    this.setAttribute("data-pane-width", String(width));
  }
  applyWidth(next, emit) {
    const clamped = this.clampWidth(next);
    this.width = clamped;
    this.syncPaneWidthVar(clamped);
    if (emit) {
      this.resizeEvent.emit({
        width: clamped
      });
    }
  }
  toggle() {
    this.setOpen(!this.isOpen());
  }
  setOpen(next) {
    const wasOpen = this.isOpen();
    if (next === wasOpen) {
      this.syncPresentation();
      this.syncPaneWidthVar();
      return;
    }
    this.open = next;
    const paneState = next ? "expanded" : "collapsed";
    this.syncPresentation();
    this.syncPaneWidthVar();
    this.toggleEvent.emit({
      open: next,
      state: paneState
    });
  }
  beginDrag(event2) {
    if (event2.button !== 0) return;
    if (this.collapsible !== "off") return;
    this.dragging = true;
    const horizontal = isHorizontalSide(this.side);
    this.dragStartCoord = horizontal ? event2.clientX : event2.clientY;
    this.dragStartSize = this.paneWidth();
    this.handleTarget?.setPointerCapture(event2.pointerId);
    document.addEventListener("pointermove", this.onPointerMove);
    document.addEventListener("pointerup", this.onPointerUp);
    document.addEventListener("pointercancel", this.onPointerUp);
  }
  endDrag() {
    if (!this.dragging) return;
    this.dragging = false;
    document.removeEventListener("pointermove", this.onPointerMove);
    document.removeEventListener("pointerup", this.onPointerUp);
    document.removeEventListener("pointercancel", this.onPointerUp);
  }
  onPointerMove(event2) {
    if (!this.dragging) return;
    const horizontal = isHorizontalSide(this.side);
    const coord = horizontal ? event2.clientX : event2.clientY;
    const delta = this.side === "right" ? this.dragStartCoord - coord : coord - this.dragStartCoord;
    this.applyWidth(this.dragStartSize + delta, true);
  }
  onPointerUp() {
    this.endDrag();
  }
  onHandlePointerDown(event2) {
    event2.preventDefault();
    this.beginDrag(event2);
  }
  onHandleKeydown(event2) {
    const keyboardEvent = event2;
    const current = this.paneWidth();
    const horizontal = isHorizontalSide(this.side);
    const prevKey = horizontal ? "ArrowLeft" : "ArrowUp";
    const nextKey = horizontal ? "ArrowRight" : "ArrowDown";
    let next = current;
    if (keyboardEvent.key === prevKey) {
      next = current - (keyboardEvent.shiftKey ? KEYBOARD_STEP_LARGE : KEYBOARD_STEP);
    } else if (keyboardEvent.key === nextKey) {
      next = current + (keyboardEvent.shiftKey ? KEYBOARD_STEP_LARGE : KEYBOARD_STEP);
    } else if (keyboardEvent.key === "Home") {
      next = this.minWidth;
    } else if (keyboardEvent.key === "End") {
      next = this.maxWidth;
    } else {
      return;
    }
    event2.preventDefault();
    this.applyWidth(next, true);
  }
  onScrimClick() {
    if (this.isMobile) {
      this.setOpen(false);
    }
  }
  onMenuLinkClick() {
    if (this.isMobile) {
      this.setOpen(false);
    }
  }
  onHostKeydown(event2) {
    const keyboardEvent = event2;
    if (keyboardEvent.key === "Escape" && this.isMobile && this.isOpen()) {
      keyboardEvent.preventDefault();
      this.setOpen(false);
      return;
    }
    if (isModifierPressed(keyboardEvent) && keyboardEvent.key.toLowerCase() === KEYBOARD_SHORTCUT) {
      keyboardEvent.preventDefault();
      this.toggle();
    }
  }
  static {
    _initClass();
  }
}
export { _RuiSidebar as RuiSidebar };